// MUI icon adapters (replacements for most SVG icons)
import { IconAddUser_MUI, IconArrowBack_MUI, IconArrowDown_MUI, IconArrowDownLarge_MUI, IconArrowLeft_MUI, IconArrowRight_MUI, IconArrowUp_MUI, IconArrowUpLarge_MUI, IconAudioOnly_MUI, IconAudioOnlyOff_MUI, IconBell_MUI, IconBluetooth_MUI, IconCalendar_MUI, IconCameraRefresh_MUI, IconCar_MUI, IconChatUnread_MUI, IconCheck_MUI, IconCloseCircle_MUI, IconCloseLarge_MUI, IconCloudUpload_MUI, IconCode_MUI, IconConnection_MUI, IconConnectionInactive_MUI, IconCopy_MUI, IconDeviceHeadphone_MUI, IconDotsHorizontal_MUI, IconDownload_MUI, IconE2EE_MUI, IconEdit_MUI, IconEnlarge_MUI, IconEnterFullscreen_MUI, IconEnvelope_MUI, IconExclamationSolid_MUI, IconExclamationTriangle_MUI, IconExitFullscreen_MUI, IconFaceSmile_MUI, IconFavorite_MUI, IconFavoriteSolid_MUI, IconFeedback_MUI, IconGear_MUI, IconHangup_MUI, IconHelp_MUI, IconHighlight_MUI, IconImage_MUI, IconInfo_MUI, IconInfoCircle_MUI, IconMessage_MUI, IconMeter_MUI, IconMic_MUI, IconMicSlash_MUI, IconModerator_MUI, IconPerformance_MUI, IconPhoneRinging_MUI, IconPin_MUI, IconPinned_MUI, IconPlay_MUI, IconPlus_MUI, IconRaiseHand_MUI, IconRecord_MUI, IconRecordAccount_MUI, IconRecordContact_MUI, IconRemoteControlStart_MUI, IconRemoteControlStop_MUI, IconReply_MUI, IconRestore_MUI, IconScreenshare_MUI, IconSearch_MUI, IconSecurityOff_MUI, IconSecurityOn_MUI, IconSend_MUI, IconShare_MUI, IconShareDoc_MUI, IconShortcuts_MUI, IconSites_MUI, IconStop_MUI, IconSubtitles_MUI, IconTileView_MUI, IconTrash_MUI, IconUser_MUI, IconUserDeleted_MUI, IconUsers_MUI, IconVideo_MUI, IconVideoOff_MUI, IconVolumeOff_MUI, IconVolumeUp_MUI, IconWarning_MUI, IconWarningCircle_MUI, IconWhiteboard_MUI, IconWifi1Bar_MUI, IconWifi2Bars_MUI, IconWifi3Bars_MUI } from './mui-adapters';
// SVG fallbacks for icons without good MUI equivalents
import { default as IconAI } from './AI.svg';
import { default as IconEmotionsAngry } from './emotions-angry.svg';
import { default as IconEmotionsDisgusted } from './emotions-disgusted.svg';
import { default as IconEmotionsFearful } from './emotions-fearful.svg';
import { default as IconEmotionsHappy } from './emotions-happy.svg';
import { default as IconEmotionsNeutral } from './emotions-neutral.svg';
import { default as IconEmotionsSad } from './emotions-sad.svg';
import { default as IconEmotionsSurprised } from './emotions-surprised.svg';
import { default as IconGoogle } from './google.svg';
import { default as IconNoiseSuppressionOff } from './noise-suppression-off.svg';
import { default as IconNoiseSuppressionOn } from './noise-suppression-on.svg';
import { default as IconOffice365 } from './office365.svg';
import { default as IconRecordLead } from './lead-record.svg';
import { default as IconRecordOpportunity } from './opportunity-record.svg';
import { default as IconRingGroup } from './icon-ring-group.svg';
import { default as IconSip } from './sip.svg';
import { default as IconWhiteboardHide } from './whiteboard-hide.svg';
import { default as IconYahoo } from './yahoo.svg';
/**
 * Map containing the default icons.
 * Most icons use MUI adapters; some keep original SVGs where no good MUI match exists.
 */
export const DEFAULT_ICON = {
    IconAddUser: IconAddUser_MUI,
    IconAI,
    IconArrowBack: IconArrowBack_MUI,
    IconArrowDown: IconArrowDown_MUI,
    IconArrowDownLarge: IconArrowDownLarge_MUI,
    IconArrowLeft: IconArrowLeft_MUI,
    IconArrowUp: IconArrowUp_MUI,
    IconArrowUpLarge: IconArrowUpLarge_MUI,
    IconAudioOnly: IconAudioOnly_MUI,
    IconAudioOnlyOff: IconAudioOnlyOff_MUI,
    IconBluetooth: IconBluetooth_MUI,
    IconBell: IconBell_MUI,
    IconCalendar: IconCalendar_MUI,
    IconCameraRefresh: IconCameraRefresh_MUI,
    IconCar: IconCar_MUI,
    IconChatUnread: IconChatUnread_MUI,
    IconCheck: IconCheck_MUI,
    IconCloseCircle: IconCloseCircle_MUI,
    IconCloseLarge: IconCloseLarge_MUI,
    IconCloudUpload: IconCloudUpload_MUI,
    IconCode: IconCode_MUI,
    IconConnection: IconConnection_MUI,
    IconConnectionInactive: IconConnectionInactive_MUI,
    IconCopy: IconCopy_MUI,
    IconDeviceHeadphone: IconDeviceHeadphone_MUI,
    IconDotsHorizontal: IconDotsHorizontal_MUI,
    IconDownload: IconDownload_MUI,
    IconE2EE: IconE2EE_MUI,
    IconEdit: IconEdit_MUI,
    IconEnlarge: IconEnlarge_MUI,
    IconEnterFullscreen: IconEnterFullscreen_MUI,
    IconEnvelope: IconEnvelope_MUI,
    IconEmotionsAngry,
    IconEmotionsDisgusted,
    IconEmotionsFearful,
    IconEmotionsHappy,
    IconEmotionsNeutral,
    IconEmotionsSad,
    IconEmotionsSurprised,
    IconExclamationSolid: IconExclamationSolid_MUI,
    IconExclamationTriangle: IconExclamationTriangle_MUI,
    IconExitFullscreen: IconExitFullscreen_MUI,
    IconFaceSmile: IconFaceSmile_MUI,
    IconFavorite: IconFavorite_MUI,
    IconFavoriteSolid: IconFavoriteSolid_MUI,
    IconFeedback: IconFeedback_MUI,
    IconGear: IconGear_MUI,
    IconGoogle,
    IconHangup: IconHangup_MUI,
    IconHelp: IconHelp_MUI,
    IconHighlight: IconHighlight_MUI,
    IconImage: IconImage_MUI,
    IconInfo: IconInfo_MUI,
    IconInfoCircle: IconInfoCircle_MUI,
    IconMessage: IconMessage_MUI,
    IconMeter: IconMeter_MUI,
    IconMic: IconMic_MUI,
    IconMicSlash: IconMicSlash_MUI,
    IconModerator: IconModerator_MUI,
    IconNoiseSuppressionOff,
    IconNoiseSuppressionOn,
    IconArrowRight: IconArrowRight_MUI,
    IconOffice365,
    IconPerformance: IconPerformance_MUI,
    IconPhoneRinging: IconPhoneRinging_MUI,
    IconPin: IconPin_MUI,
    IconPinned: IconPinned_MUI,
    IconPlay: IconPlay_MUI,
    IconPlus: IconPlus_MUI,
    IconRaiseHand: IconRaiseHand_MUI,
    IconRecord: IconRecord_MUI,
    IconRecordAccount: IconRecordAccount_MUI,
    IconRecordContact: IconRecordContact_MUI,
    IconRecordLead,
    IconRecordOpportunity,
    IconRemoteControlStart: IconRemoteControlStart_MUI,
    IconRemoteControlStop: IconRemoteControlStop_MUI,
    IconReply: IconReply_MUI,
    IconRestore: IconRestore_MUI,
    IconRingGroup,
    IconScreenshare: IconScreenshare_MUI,
    IconSearch: IconSearch_MUI,
    IconSecurityOff: IconSecurityOff_MUI,
    IconSecurityOn: IconSecurityOn_MUI,
    IconSend: IconSend_MUI,
    IconShare: IconShare_MUI,
    IconShareDoc: IconShareDoc_MUI,
    IconShortcuts: IconShortcuts_MUI,
    IconSip,
    IconSites: IconSites_MUI,
    IconStop: IconStop_MUI,
    IconSubtitles: IconSubtitles_MUI,
    IconTileView: IconTileView_MUI,
    IconTrash: IconTrash_MUI,
    IconUserDeleted: IconUserDeleted_MUI,
    IconUsers: IconUsers_MUI,
    IconUser: IconUser_MUI,
    IconVideo: IconVideo_MUI,
    IconVideoOff: IconVideoOff_MUI,
    IconVolumeOff: IconVolumeOff_MUI,
    IconVolumeUp: IconVolumeUp_MUI,
    IconWarning: IconWarning_MUI,
    IconWarningCircle: IconWarningCircle_MUI,
    IconWhiteboard: IconWhiteboard_MUI,
    IconWhiteboardHide,
    IconWifi1Bar: IconWifi1Bar_MUI,
    IconWifi2Bars: IconWifi2Bars_MUI,
    IconWifi3Bars: IconWifi3Bars_MUI,
    IconYahoo
};
